import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFoundPage from '../NotFoundPage.vue'
import Index from './Index'

Vue.use(VueRouter)

const routes = [
  {
    name: 'Index',
    path: '/',
    component: Index
  },
  {
    path: '*',
    component: NotFoundPage
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, _, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '健而康科技'
    // document.title = '健而康科技信息服务（中山）有限公司'
  }
  return next()
})

export default router
